module.exports = __webpack_public_path__ + "static/media/LoginImage.54101cd7.jpg";